module.exports = __webpack_public_path__ + "static/img/small-bg.f8dba2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/small-bg.png
// module id = 3dXf
// module chunks = 1